import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from '../../helpers/propTypes';
import ButtonWithArrow from '../Buttons/ButtonWithArrow';

const useStyles = makeStyles((theme) => ({
  actionButton: {
    color: theme.palette.grey[400],
  },

  root: {
    flex: 1,

    '@media print': {
      display: 'none',
    },
  },
}));

function Actions({ close }) {
  const classes = useStyles();

  return (
    <Grid className={classes.root} container justifyContent="space-between">
      <ButtonWithArrow
        arrowSide="left"
        className={classes.actionButton}
        compact
        onClick={close}
      >
        <FormattedMessage defaultMessage="Back" id="Terms.back" />
      </ButtonWithArrow>
    </Grid>
  );
}

Actions.propTypes = {
  close: PropTypes.func.isRequired,
};

export default Actions;
